export default function CTASection() {
  return (
    <section className="bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6 py-16 md:py-24 text-center">
        <div className="relative rounded-2xl overflow-hidden h-56 md:h-72 mb-10 md:mb-14">
          <img
            src="https://readdy.ai/api/search-image?query=Beautifully%20styled%20product%20flat%20lay%20with%20white%20sneakers%20beige%20knit%20sweater%20leather%20handbag%20gold%20jewelry%20and%20modern%20tech%20gadgets%20on%20textured%20cream%20linen%20fabric%20soft%20natural%20sunlight%20editorial%20lifestyle%20photography%20with%20subtle%20film%20grain&width=1400&height=600&seq=cta-v2-showcase-g3p7s&orientation=landscape"
            alt="Vigorbuy Spreadsheet product showcase"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-black/10"></div>
        </div>

        <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 leading-tight mb-3">
          Ready to Explore <em className="not-italic text-primary-600">Vigorbuy Spreadsheet</em>?
        </h2>
        <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto mb-8 leading-relaxed">
          Start discovering products faster with the latest <strong>Vigorbuy Spreadsheet</strong>—your trusted resource for smarter buying decisions.
        </p>

        <a
          href="https://kaspreadsheet.com"
          target="_blank"
          rel="noopener nofollow"
          className="inline-flex items-center gap-2 px-10 py-4 rounded-full bg-foreground-950 text-white text-base font-semibold whitespace-nowrap cursor-pointer hover:bg-foreground-800 transition-colors"
        >
          Buy It Now
          <i className="ri-arrow-right-up-line text-lg"></i>
        </a>
      </div>
    </section>
  );
}